/* global dataLayer, _cc10461, Sailthru */

import { GTM_EVENTS } from "config/constants";

export function setPageTitleInDataLayer() {
  if (document.title.indexOf(" - Axios") > 0) {
    const slicedTitle = document.title.slice(
      0,
      document.title.indexOf(" - Axios")
    );
    dataLayer.push({ title: slicedTitle });
  }
}

export function setUserInDataLayer(id, isLoggedIn) {
  dataLayer.push({
    "userID Data Layer Var": id,
    "User Logged In": isLoggedIn,
  });
}

export function trackPageView() {
  dataLayer.push({
    Card: false,
    event: GTM_EVENTS.PAGE_VIEW,
  });
}

export function resetContentValues() {
  return {
    Headline: "",
    Authors: "",
    Editors: "",
    "Published Date": "",
    "Primary Section": "",
    Sections: "",
    "Primary Tag": "",
    Tags: "",
    Permalink: "",
    Rubric: "",
    Featured: "",
  };
}

export function getDataLayerForStream(stream) {
  const extraContent = stream.extraContent || {};
  return {
    "Stream Lookup": stream.lookup,
    "Stream Type": stream.type,
    "Stream Display Name": stream.displayName,
    "Stream Query Param Override": stream.override,
    "Stream After Permalink": extraContent.slug,
    "Stream Type After Permalink": extraContent.__typename
      ? extraContent.__typename.toLowerCase()
      : undefined,
  };
}

export function getDataLayerForCard({ edge, position }) {
  const story = edge.node;
  const { featured } = edge;

  switch (edge.node.__typename) {
    case "Content":
      return {
        Headline: story.headline,
        Authors:
          story.authors &&
          story.authors.map(author => author.display_name).join("|"),
        Editors:
          story.editors &&
          story.editors.map(editor => editor.display_name).join("|"),
        "Published Date": story.published_date,
        "Primary Section": story.primary_section && story.primary_section.name,
        Sections:
          story.sections &&
          story.sections.map(section => section.name).join("|"),
        "Primary Tag": story.primary_tag && story.primary_tag.name,
        Tags: story.tags && story.tags.map(tag => tag.name).join("|"),
        "Post ID": story.id,
        Permalink: story.permalink,
        Card: true,
        "Card Count": 1,
        Rubric: story.rubric && story.rubric.name,
        Featured: featured,
        Position: position + 1,
        "Card Type": story.__typename,
      };
    default:
      return {
        ...resetContentValues(),
        Card: true,
        "Card Count": 1,
        "Card Type": edge.node.__typename,
        Position: position + 1,
        "Post ID": edge.node.id,
      };
  }
}

export function streamItemDataLayerEvent({ stream, edge, position }, event) {
  dataLayer.push({
    ...getDataLayerForStream(stream),
    ...getDataLayerForCard({ edge, position }),
    event,
  });
}
